import { render, staticRenderFns } from "./CurationEmptyLink.vue?vue&type=template&id=98f73bfa&scoped=true&"
import script from "./CurationEmptyLink.vue?vue&type=script&lang=js&"
export * from "./CurationEmptyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f73bfa",
  null
  
)

export default component.exports